import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/client/app/product/[prd]/ProductPageClient.js");
